<template>
  <div>
    <el-dialog
      class="dialog-vip-price"
      title="提示"
      :visible="visible"
      append-to-body
      width="640px"
    >
      <div class="modal-title">开通会员</div>
      <div class="modal-content">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-form-item label="选择会员等级" prop="vip_id">
            <el-radio-group v-model="ruleForm.vip_id" @change="levelChange">
              <el-radio v-for="item in vip_list" :key="item.id" :label="item.id">
                {{ item.name }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="会员时长" prop="type">
            <el-radio-group v-model="ruleForm.type">
              <el-radio
                v-for="(item, index) in type"
                :key="index + 1"
                @change="() => typeChange(item)"
                :label="index + 1"
              >
                {{ `${item.type_open_number}${item.type != 5 ? '个' : ''}${item.typeName}` }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="会员等级权限" v-if="privilegeList && privilegeList.length > 0">
            <div class="authority" v-for="item in privilegeList" :key="item.id">
              <img src="@/assets/images/vip/select.png" />
              <span>{{ item.name }}</span>
            </div>
          </el-form-item>
          <el-form-item label="价格" v-if="ruleForm.type">
            <div class="vip-price">
              <CurrencyNew
                :price="ruleForm.price"
                :priceTwo="true"
                :isUnderlineLeft="false"
              ></CurrencyNew>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <template v-slot:footer>
        <el-button type="default" @click="cancel">取消</el-button>
        <el-button type="primary" @click="confirm" :disabled="!ruleForm.type"> 确定 </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { VipLevelType } from '@/utils/enums.js';
export default {
  name: 'VipOPenModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      ruleForm: {
        vip_id: '',
        type: '',
        price: 0,
        type_open_number: 1,
        vip_type: '',
      },
      authority: [
        {
          id: 'vip_key_course_discount',
          name: '会员专享课程',
        },
        {
          id: 'vip_key_package_discount',
          name: '会员专项套卷折扣',
        },
        {
          id: 'vip_key_special_exercises',
          name: '专项练习无限畅刷',
        },
        {
          id: 'vip_key_random_exercises',
          name: '随机练习无限畅刷',
        },
        {
          id: 'vip_key_free_combine',
          name: '自由组卷无限畅刷',
        },
        {
          id: 'vip_key_error_collect',
          name: '错题集无限畅刷',
        },
      ],
      privilegeList: [],
      rules: {
        vip_id: [{ required: true, message: '请选择会员等级', trigger: 'blur' }],
        type: [{ required: true, message: '请选择时长', trigger: 'blur' }],
      },

      type: [],
      vip_list: [],
    };
  },
  watch: {
    value(value) {
      this.visible = value;
      if (value) {
        this.getLevelList();
      }
    },
  },
  methods: {
    //会员等级列表
    async getLevelList() {
      const res = await this.$http.get('/api/app/vip/all_vip_info');
      this.vip_list = res.map((item) => ({ ...item, id: item.id }));
      this.ruleForm.vip_id = res && res.length > 0 ? res[0].id : '';
      res && res.length > 0 && (await this.handleClick());
    },
    //根据会员等级查询相应的会员等级的信息
    async handleClick() {
      const res = await this.$http.get(`/api/app/vip/vip_info/${this.ruleForm.vip_id}`);
      const data = res.attr_data || {};
      this.type = res.price_data.map((i) => ({
        ...i,
        typeName: VipLevelType.getValue(i.type),
      }));

      //筛选出享受的特权折扣项
      this.privilegeList = this.authority.map((item) => {
        let name = item.name;
        if (item.id == 'vip_key_package_discount' && data[item.id]) {
          if (data[item.id].switch == 2) {
            name = '会员专项套卷折扣';
          } else {
            name = '套卷练习无限畅刷';
          }
        }
        return {
          ...item,
          switch: data[item.id] && data[item.id].switch,
          name,
        };
      });
      this.privilegeList = this.privilegeList.filter((i) => i.switch && i.switch != 0);
    },
    //会员等级选择
    async levelChange() {
      await this.handleClick();
      this.ruleForm.type = '';
    },
    //开通时长选择
    typeChange(item) {
      // console.log(item, this.type);
      // const data = this.type.filter(i => i.type == this.ruleForm.type);
      // if (data && data.length > 0) {
      //   this.ruleForm.price = data[0].price;
      // }
      const data = this.type.find(
        (i) => i.type == item.type && i.type_open_number == item.type_open_number,
      );
      this.ruleForm.type_open_number = item.type_open_number;
      this.ruleForm.vip_type = item.type;
      if (data) {
        this.ruleForm.price = data.price;
      }
    },
    confirm() {
      this.$router.push({
        name: 'OrderConfirm',
        params: { id: this.ruleForm.vip_id },
        query: {
          type: 20,
          type_open_number: this.ruleForm.type_open_number,
          dateLength: this.ruleForm.vip_type,
        },
      });
    },
    cancel() {
      this.visible = false;
      this.$emit('input', false);
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-vip-price {
  text-align: center;
  ::v-deep .el-form-item__label {
    text-align: left;
  }
  ::v-deep .el-radio {
    //width: 120px;
    margin-bottom: 10px;
  }

  ::v-deep {
    .el-form-item {
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 22px;
      }
    }

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      padding: 0;
    }
    .modal-title {
      height: 24px;
      font-size: 18px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      text-align: LEFT;
      color: #333333;
      line-height: 24px;
      padding: 24px 0 16px 24px;
    }
    .modal-content {
      padding: 0 24px 0 24px;
      text-align: left;
      .authority {
        img {
          vertical-align: middle;
          width: 16px;
          height: 16px;
          margin-right: 8px;
        }
        span {
          vertical-align: middle;
          display: inline-block;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: #333333;
          line-height: 32px;
        }
      }
      .vip-price {
        .price-wrap {
          display: inline-block;
          //margin-top: 7px;
        }
      }
    }
    .el-dialog__footer {
      padding: 0 24px 24px 0;
      text-align: right;
    }
  }
  ::v-deep .el-radio-group {
    vertical-align: top;
    line-height: 40px;
    font-size: 14px;
  }
}
</style>
